import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "../ReduxSlice/Auth/authSlice";
import eventSlice from "../ReduxSlice/Event/eventSlice";
import cartSlice from "../ReduxSlice/Checkout/cartSlice";
import UiSlice from "../ReduxSlice/Ui/UiSlice";
import guardSlice from "../ReduxSlice/Auth/guardSlice";
import checkInCheckoutSlice from "../ReduxSlice/Guard/checkInCheckoutSlice";

const persistConfig = {
  key: "root",
  storage,
};

const store = configureStore({
  reducer: {
    user: persistReducer(persistConfig, authReducer),
    event: eventSlice,
    cart: cartSlice,
    UiNotification: UiSlice,
    guard: guardSlice,
    checkInCheckOut: persistReducer(persistConfig, checkInCheckoutSlice),
  },
});

export const persistor = persistStore(store);

export default store;
